import { atom } from 'jotai'
// import { OwnerContacts } from 'src/v2/views/owner-reveal/insights/owner-contacts'
import { OwnerSummary } from 'src/v2/views/owner-reveal/insights/owner-summary'
import { Parcels } from 'src/v2/views/owner-reveal/insights/parcels'
import { PortfolioSummary } from 'src/v2/views/owner-reveal/insights/portfolio-summary'
import { AcquisitionHistory } from 'src/v2/views/owner-reveal/insights/acquisition-history'
// import { RelatedEntities } from 'src/v2/views/owner-reveal/insights/related-entities'
import { ReportedOwners } from 'src/v2/views/owner-reveal/insights/parcel-insights/reported-owners'
import { PropertyRecords } from 'src/v2/views/owner-reveal/insights/parcel-insights/property-records'
import { ParcelZoning } from 'src/v2/views/owner-reveal/insights/parcel-insights/zoning'
import { GraphMapInsight } from 'src/v2/views/owner-reveal/insights/owner-graph-map/graph-map-widget'
import { RootEntities } from 'src/v2/views/owner-reveal/insights/root-entities'
import { Colors } from 'src/components/theme'
import { Insight } from 'src/components/insights/types'
import { SidebarInsightsMenuItem } from 'src/v2/components/sidebar-insights-menu'

// Grouping insights by category
export const OWNER_REPORTS_MENU_ITEMS = [
  OwnerSummary,
  // OwnerContacts, // TODO: re enable this OwnerContacts page once we have the final version to implement
  // RelatedEntities,
  GraphMapInsight,
  RootEntities,
].map((insight) => ({
  id: insight.id,
  tabId: insight.tabId,
  name: insight.name,
  secondaryColor: Colors.primaryRed50,
  color: Colors.primaryRed800,
  icon: insight.icon,
}))

export const PORTFOLIO_REPORTS_MENU_ITEMS = [PortfolioSummary, Parcels, AcquisitionHistory].map((insight) => ({
  id: insight.id,
  tabId: insight.tabId,
  name: insight.name,
  secondaryColor: Colors.primaryRed50,
  color: Colors.primaryRed800,
  icon: insight.icon,
}))

export const PARCEL_REPORTS_MENU_ITEMS: SidebarInsightsMenuItem[] = [
  PropertyRecords,
  ParcelZoning,
  GraphMapInsight,
].map((insight) => ({
  id: insight.id,
  tabId: insight.tabId,
  name: insight.name,
  secondaryColor: Colors.primaryGreen50,
  color: Colors.primaryGreen800,
  icon: insight.icon,
}))

const OWNERSHIP_INSIGHTS = [
  // entity insights
  OwnerSummary,
  // OwnerContacts,
  // RelatedEntities,
  Parcels,
  PortfolioSummary,
  AcquisitionHistory,
  GraphMapInsight,
  RootEntities,

  // parcel insights
  ReportedOwners,
  PropertyRecords,
  ParcelZoning,
]

export const insights = atom<Insight[]>(OWNERSHIP_INSIGHTS)
